import { AutogenModelPostedWire, AutogenRowPostedWire } from "./autogen/AutogenModelPostedWire";

export class ModelPostedWire extends AutogenModelPostedWire<RowPostedWire> {
	constructor() {
		super(RowPostedWire);
	}
}

export class RowPostedWire extends AutogenRowPostedWire {
}